import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 5%;
  background: #ffffff;
  color: #1e2326;
  font-family: 'Montserrat', sans-serif;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); /* Improved shadow */
  width: 100%;
`;

const ContentWrapper = styled.div`
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled.img`
  height: 44px; /* Slightly larger */
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

const NavContainer = styled.nav`
  display: flex;
  align-items: center;
  gap: 30px;

  @media (max-width: 850px) {
    display: none;
  }
`;

const NavLink = styled.a`
  text-decoration: none;
  color: #2b3e51; /* Darker for better contrast */
  font-size: 15px;
  font-weight: 600;
  transition: color 0.3s;

  &:hover {
    color: #25aae3;
  }
`;

const GetStartedButton = styled.a`
  background: #fa6582;
  border: 2px solid #fa6582;
  color: #ffffff; /* Use solid background instead of outline for better contrast */
  padding: 10px 24px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  margin-left: 10px;
  box-shadow: 0 4px 10px rgba(250, 101, 130, 0.3);

  &:hover {
    background: transparent;
    color: #fa6582;
    box-shadow: none;
  }
`;

const Header = () => {
  return (
    <HeaderContainer>
      <ContentWrapper>
        <a href="#home">
          <Logo src="/Logo.webp" alt="Gainsta Logo" />
        </a>
        <NavContainer>
          <NavLink href="#home">Home</NavLink>
          <NavLink href="#faq">FAQ</NavLink>
          <NavLink href="#capabilities">Capabilities</NavLink>
          <NavLink href="#pricing">Pricing</NavLink>
          <NavLink href="#contact">Contact</NavLink>
          <GetStartedButton href="#pricing">GET STARTED</GetStartedButton>
        </NavContainer>
      </ContentWrapper>
    </HeaderContainer>
  );
};

export default Header;
